import { RECRUITEE_BACKEND } from '@core/environment-legacy/staging';

import type { TellentClientSetupEnvironment } from './interface';

export const environment: TellentClientSetupEnvironment = {
  environmentName: 'development',
  angularProdMode: false,
  tellentApiUrl: RECRUITEE_BACKEND.tellentApiUrl,
  tellentAuthUrl: RECRUITEE_BACKEND.tellentAuthUrl,
  tellentAppUrl: RECRUITEE_BACKEND.tellentAppUrl,
  tellentApiWsUrl: RECRUITEE_BACKEND.tellentAppWsUrl,
  reportsApiUrl: RECRUITEE_BACKEND.reportsApiUrl,
  tellentOneDomainUrl: RECRUITEE_BACKEND.tellentOneDomainUrl,
  tellentWebsiteUrl: RECRUITEE_BACKEND.tellentWebsiteUrl,
};
